jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.signposting.popups').length ) {
        let $ = jQuery;

        $(".signposting.popups .signposts .signpost").on('click', function(e) {
           e.preventDefault();
           let $index = $(this).data('index');
           showPopup($(this), $index);

        });

        function showPopup($this, $index) {
            let $content = $this.parents('.signposting').find('.popup-content [data-popup_index="' + $index + '"]');
            let $popup = $('.signposting-popup');

            // Reset video and image elements
            $popup.find('#popup-video').removeClass('show');
            $popup.find('#popup-video source').attr('src', '');
            $popup.find('#popup-video').attr('poster', '');
            $popup.find('.popup-image').removeClass('show');
            $popup.find('.popup-image').attr('src', '');

            // Set content inside popup
            $popup.find('.popup-content-wrap').html($content.html());

            // Check if video data is available
            let videoSrc = $content.data('video');
            let imageSrc = $content.data('image');
            let hasPopup = $content.attr('data-hasContent');
            console.log(hasPopup);

            if(hasPopup === 'false') {
                $('.popup-content-wrap').hide();
            } else {
                $('.popup-content-wrap').show();
            }

            if (videoSrc !== '') {
                // Set video source and poster
                // $popup.find('#popup-video source').attr('src', videoSrc);
                // $popup.find('#popup-video-frame').attr('src', videoSrc);
                $popup.find('#popup-video').attr('poster', imageSrc);
                changeSource(videoSrc);

            } else {
                // Show image if no video source
                $popup.find('.popup-image').attr('src', imageSrc).addClass('show');
            }
            $popup.addClass('show');
        }


        function changeSource(url) {
            var video = document.getElementById('popup-video');
            var iframe = document.getElementById('popup-video-frame');
            if(isYoutubeURL(url)) {
                url = convertToEmbeddableYouTubeURL(url);
                iframe.style.display = 'block';
                iframe.src = url;
                video.style.display = 'none';
            } else {
                if (isMp4Url(url)) {
                    video.style.display = 'block';
                    video.src = url;
                    video.play();
                    iframe.style.display = 'none';
                } else {
                    url = formatIframeUrl(url);
                    iframe.style.display = 'block';
                    iframe.src = url;
                    video.style.display = 'none';
                }
            }
            console.log(url);
        }

        function isMp4Url(url) {
            return url.match(/\.(mp4|avi|mov|mkv)$/i);
        }

        function formatIframeUrl(url) {
            // Check if the URL is a YouTube or YouTube Shorts link
            const youtubeMatch = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|shorts\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i);
            if (youtubeMatch && youtubeMatch[1]) {
                return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
            }

            // Check if the URL is a Vimeo link
            const vimeoMatch = url.match(/vimeo\.com\/(?:channels\/[\\w]+\/|groups\/[\\w]+\/videos\/|album\/[\\d]+\/video\/|video\/|)([0-9]+)/);
            if (vimeoMatch && vimeoMatch[1]) {
                return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
            }

            // Check if the URL is an MP4 link
            const mp4Match = url.match(/\.mp4$/i);
            if (mp4Match) {
                return url;
            }

            // If the URL doesn't match any of the above, return null or an error
            return null;
        }


        function isYoutubeURL(url) {
            const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|shorts\/|embed\/|v\/)?([a-zA-Z0-9_-]{11})(&.*)?$/;

            return youtubeRegex.test(url);
        }

        function convertToEmbeddableYouTubeURL(url) {
            const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|shorts\/|embed\/|v\/)?([a-zA-Z0-9_-]{11})(&.*)?$/;

            // Check if the URL matches YouTube URL patterns
            const match = url.match(youtubeRegex);

            if (match && match[5]) {
                const videoId = match[5];
                return `https://www.youtube.com/embed/${videoId}`;
            } else {
                return null; // Return null if it's not a valid YouTube URL
            }
        }



        $(".signposting-popup .close").on('click', function(e) {
            $(".signposting-popup").removeClass("show");
        });


    }
});